<div class="sidebar" [ngClass]="{'sidebar-open': isSidebarOpen === true , 'sidebar-close': isSidebarOpen === false}" >
    <img src="/assets/images/Logo.png" class="ms-2 my-2" alt="">

    <ul class="sidebar-ul">
        <ng-container *ngFor="let sidebarnavItem of sidebarnavItems; index as i">

            <li *ngIf="sidebarnavItem">
                <a *ngIf="!(sidebarnavItem.path && sidebarnavItem.path != '')" class="mb-3 {{sidebarnavItem.class}}"
                    (click)="toggleSide($event)" (click)="addExpandClass(sidebarnavItem.title)" [routerLink]=""
                    [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                    <i *ngIf="sidebarnavItem.icon && sidebarnavItem.icon != ''" [ngClass]="[sidebarnavItem.icon]"
                        aria-hidden="true"></i>
                    <img *ngIf="sidebarnavItem.image && sidebarnavItem.image != ''" src="{{sidebarnavItem.image}}"
                        [ngClass]="[sidebarnavItem.imageclass]" alt="">
                    <span class="hide-menu">{{sidebarnavItem.title}}</span>
                </a>

                <a *ngIf="sidebarnavItem.path && sidebarnavItem.path != ''" 
                    class="mb-3 {{sidebarnavItem.class}} sidebar-link"
                    (click)="toggleSide($event)"
                    [routerLink]="[sidebarnavItem.path]"
                    queryParamsHandling="preserve"
                    [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
                    <i *ngIf="sidebarnavItem.icon && sidebarnavItem.icon != ''" [ngClass]="[sidebarnavItem.icon]"
                        aria-hidden="true"></i>
                    <img *ngIf="sidebarnavItem.image && sidebarnavItem.image != ''" src="{{sidebarnavItem.image}}"
                        [ngClass]="[sidebarnavItem.imageclass]" alt="">
                    <span class="hide-menu">{{sidebarnavItem.title}}</span>
                </a>



                <ul id="menuitem-{{i}}" aria-expanded="false" class="collapse link-sublist sidebar-ul"
                    *ngIf="sidebarnavItem.submenu.length > 0" [ngClass]="{'show' : isSameLabel(sidebarnavItem.title) }">
                    <li class="sidebar-item mb-3" *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu"
                        routerLinkActive="active" [ngClass]="[sidebarnavSubItem.class]">
                        <a  class="sidebar-link has-arrow" 
                            (click)="toggleSide($event)"
                            [routerLink]="[sidebarnavSubItem.path]"
                            queryParamsHandling="preserve"
                            [routerLinkActive]="sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active link-active'">
                            <i *ngIf="sidebarnavSubItem.icon && sidebarnavSubItem.icon != ''"
                                [ngClass]="[sidebarnavSubItem.icon]" aria-hidden="true"></i>
                            <img *ngIf="sidebarnavSubItem.image && sidebarnavSubItem.image != ''"
                                src="{{sidebarnavSubItem.image}}" [ngClass]="[sidebarnavSubItem.imageclass]" alt="">

                            <span class="hide-menu">{{sidebarnavSubItem.title}}</span>
                        </a>
                    </li>
                </ul>
            </li>

        </ng-container>
    </ul>
</div>